import React, { Component } from 'react'
import './css.css';

class Features extends Component {
   
    render(){
        console.log(this.props.update) 
        return ( 
            <div>
                <div id="bows_flyer" className="text white">
                    <div id="bows_mainlabel">💈 PLATFORM FUNCTIONALITIES</div>
                    <div id="bows_sublabel">All you can do in 🌈SmartShop</div>
                    <div className="bows_panel dark darkblue text white">
                        <div className="instructions_title light lightblue text white">🐈 BUY & SELL CRYPTO ASSETS</div>
                        <br></br>
                        An Ecosystem full of e-commerce shops and modular vending-machines for cryptos.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">💫 SWAP ASSETS AND GOODS</div>
                        <br></br>
                        All Shops can connect together forming a giant ecxhange platform.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🚿 Create Crypto-taps</div>
                        <br></br>
                        Autonomous automatic crypto-taps. Set a price, fill the box, see it flowing, then refill and so on.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🎁 Offer Freebies</div>
                        <br></br>
                        Tools for distribution of Freebies in any Ethereum format.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🐳 BUILD YOUR DEFI BASE</div>
                        <br></br>
                        More modules are coming, more features means more possibilities!
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">💰 JOIN A REFERRAL ECONOMY</div>
                        <br></br>
                        All SmartShop is Referral oriented, you earn ten times more here than in other places. SmartShop belongs to the community.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🎎 BUILD COMMUNITIES</div>
                        <br></br>
                        The best way to engage your community is to give them a twitter-like display full of your cryptos/digital/NFTs to refer to.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🏰 BUILD A REFERRAL ECONOMY</div>
                        <br></br>
                        Build a district with third party shops, earn from it!
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🎉 POST CRYPTOS</div>
                        <br></br>
                        It's like twitter, but you post cryptos.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">📯 EARN BY SHOPPING FEEDS</div>
                        <br></br>
                        Aggregate third party content (offers), share the aggregation in a GhostShop or a GhostFeed and earn from referrals.
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">💖 EARN CREATING IDEAS</div>
                        <br></br>
                        Only the community would pay you forever just because you had an idea for first
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">⚗️ EARN BUILDING SHOP_MODULES</div>
                        <br></br>
                        Devs can build their own throne inside SmartShop by building modules
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🌾 EARN BY FARMING/STAKING</div>
                        <br></br>
                        Part of the platform income will become earning offers. Forever!
                        <br></br><br></br><br></br>
                        <div className="instructions_title light lightblue text white">🍀 JOIN REFERRAL LOTTERY</div>
                        <br></br>
                        A lottery out of our control. Paying the luckiest of us.
                        <br></br><br></br><br></br>
                        
                    </div>
                </div>
            </div>
        );
    }

}

export default Features